import { useEffect, useRef, useState } from 'react'
import { useLazyQuery } from '@apollo/client'
import { useRouter } from 'next/router'

import { GET_ARTICLE_ID } from '@graphql/article/article.query'
import { GET_PLAYERS } from '@graphql/players/players.query'
import { preparePlayerInfoCompression } from '@shared/libs/player-comparison'

function usePlayerCompare({ p1Seo, p2Seo, p1Detail, p2Detail }) {
  const route = useRouter()
  const firstSeo = useRef(p1Seo)
  const secondSeo = useRef(p2Seo)
  const [firstPlayer, setFirstPlayer] = useState(p1Detail)
  const [secondPlayer, setSecondPlayer] = useState(p2Detail)
  const playerInfo = preparePlayerInfoCompression(firstPlayer, secondPlayer)

  const [getSeoData] = useLazyQuery(GET_ARTICLE_ID)
  const [getFirstPlayer] = useLazyQuery(GET_PLAYERS, {
    onCompleted: (data) => setFirstPlayer(data?.getPlayerByIdFront)
  })
  const [getSecondPlayer] = useLazyQuery(GET_PLAYERS, {
    onCompleted: (data) => setSecondPlayer(data?.getPlayerByIdFront)
  })

  async function hitFirstPlayer(player) {
    const { data } = await getSeoData({ variables: { input: { sSlug: player?.oSeo?.sSlug } } })
    firstSeo.current = data?.getSeoData
    getFirstPlayer({ variables: { input: { _id: player?._id } } })
  }

  async function hitSecondPlayer(player) {
    const { data } = await getSeoData({ variables: { input: { sSlug: player?.oSeo?.sSlug } } })
    secondSeo.current = data?.getSeoData
    getSecondPlayer({ variables: { input: { _id: player?._id } } })
  }

  function makeSeo() {
    const p1Name = firstPlayer?.sFullName || firstPlayer?.sFirstName || ''
    const p2Name = secondPlayer?.sFullName || secondPlayer?.sFirstName || ''
    return {
      sTitle: `${p1Name} ${p2Name ? 'vs' : ''} ${p2Name} - Players Comparison`,
      sDescription: `Compare ${p1Name} ${p2Name ? '&' : ''} ${p2Name} - Stats, Achievements, Performance. Who excels in batting, bowling, fielding, and more`,
      aKeywords: ['player comparison'],
      eType: 'cp', // Static type for now
      sSlug: route?.asPath?.split('?')[0]
    }
  }

  useEffect(() => {
    function handleChangePlayer({ detail }) {
      detail?.willChange === 1 ? hitFirstPlayer(detail?.player) : hitSecondPlayer(detail?.player)
    }
    window.addEventListener('changePlayer', handleChangePlayer)
    return () => window.removeEventListener('changePlayer', handleChangePlayer)
  }, [])

  return {
    seoData: makeSeo(),
    firstPlayer,
    secondPlayer,
    playerInfo
  }
}
export default usePlayerCompare
